'use client'

import {
  IconChevronDown,
  IconSpotFill,
  IconXCircleFill,
} from '@/shared/assets/icons'
import { DividerVertical } from '@/shared/design-system/components/Divider/Vertical'
import { logEvent } from '@/shared/external/firebase/analytics'
import { EVENT_NAMES, LABELS } from '@/shared/lib/analytics'

interface ISearchPlaceFieldProps {
  inputRef: React.RefObject<HTMLInputElement | null>
  inputValue: string
  region3DepthName: string
  onClickSearchPlace: (e: React.KeyboardEvent<HTMLInputElement>) => void
  onChangeInput: (e: React.ChangeEvent<HTMLInputElement>) => void
  onClickClearInput: () => void
  onClickSearchAddress: () => void
}

const PlaceSearchField = ({
  inputRef,
  inputValue,
  region3DepthName,
  onClickSearchPlace,
  onChangeInput,
  onClickClearInput,
  onClickSearchAddress,
}: ISearchPlaceFieldProps) => {
  return (
    <div className='w-full pt-dimension-x4 px-dimension-x4 pb-dimension-x3 bg-background-surface-default sticky top-0 z-99'>
      <div className='w-full flex items-center justify-between gap-x2 py-dimension-x2 pl-dimension-x3 pr-dimension-x1 bg-background-neutral-weak rounded-xl overflow-hidden'>
        <div className='flex-1 flex items-center gap-dimension-x2 justify-between min-w-0'>
          <div
            className='flex items-center justify-between gap-dimension-x1 h-dimension-x8'
            onClick={onClickSearchAddress}
          >
            <IconSpotFill fill='#505C66' width='16' height='16' />
            <p className='max-w-dimension-x14 truncate text-title-2-semibold text-foreground-neutral-normal'>
              {region3DepthName}
            </p>
            <IconChevronDown fill='#505C66' width='14' height='14' />
          </div>
          <DividerVertical
            w='w-[1px]'
            h='h-dimension-x5'
            color='bg-stroke-neutral-strong'
          />
          <input
            ref={inputRef}
            type='text'
            value={inputValue}
            placeholder='정비소를 검색하세요'
            className='flex-1 text-title-2-medium text-foreground-neutral-strong caret-foreground-brand-strong truncate min-w-0'
            onChange={onChangeInput}
            onKeyDown={onClickSearchPlace}
            onClick={() =>
              logEvent(EVENT_NAMES.WEB_VIEW.SEO.CLICK.SEARCH_ITEM, {
                label: LABELS.WEB_VIEW.SEO.CLICK.SEARCH_KEYWORD_INPUT,
              })
            }
          />
        </div>

        {inputValue && (
          <button
            className='w-dimension-x8 h-dimension-x8 flex items-center justify-center p-dimension-x2 min-w-0'
            onClick={onClickClearInput}
          >
            <IconXCircleFill fill='#8E98A0' width='16' height='16' />
          </button>
        )}
      </div>
    </div>
  )
}

export default PlaceSearchField
